import { render } from "./Dashboard.vue?vue&type=template&id=4b045a96&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=4b045a96&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=4b045a96&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b045a96"]])

export default __exports__